/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const root = (typeof window !== "undefined") ? window : globalThis;

const initRecaptcha = function(el) {
  const $el = $(el);
  return grecaptcha.render(el,
    {'sitekey': recaptcha_site_key} );
};

root.initRecaptchas = () => $('.recaptcha').each(function() {
  return initRecaptcha(this);
});
